import { render, staticRenderFns } from "./UsersClubEvents.vue?vue&type=template&id=19a9ff28"
import script from "./UsersClubEvents.vue?vue&type=script&lang=js"
export * from "./UsersClubEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports